export default {
  init() {
    $(window).scroll(function () {
      var scrollTop = $(window).scrollTop();

      if (scrollTop > 10) {
        $('header').addClass('hasscrolled');
      } else {
        $('header').removeClass('hasscrolled');
      }
    });

    // JavaScript to be fired on all pages
    jQuery('.wpcf7-custom-submit').on('click', function () {
      jQuery(this).closest('form').submit();
    });

    jQuery('#menu_toggle').on('click', () => {
      jQuery('nav.nav-primary').toggleClass('menu-open');
      jQuery('#menu_toggle').toggleClass('hamburger-open');
    });

    jQuery('.search-toggle').on('click', () => {
      jQuery('.searchform-desktop').toggleClass('search-open');
    });

    jQuery('.search-exit').on('click', () => {
      jQuery('.searchform-desktop').toggleClass('search-open');
    });

    if ($( window ).width() < 992) {
      $('.menu-item-has-children').append('<span class="dropdown-button"></span>');
      $('.dropdown-button').click(function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('sub-menu-open');
      });
    }

    jQuery('section.content-ticket-request a.add_to_cart').on('click', (e) => {
      e.preventDefault();

      // if element with class multidate-variations-select exists, show alert
      let multidateSelect = jQuery('.multidate-variations-select');
      if (multidateSelect.length && !multidateSelect.val()) {
        alert('Selecteer eerst een datum');
        return;
      }

      let variations = [];
      let productId;

      jQuery('section.content-ticket-request .default-variations-container .custom-control-input:checked').each(function () {
        variations.push({id: parseInt($(this).data('variation-id')), qty: 1});
        productId = parseInt($(this).data('product-id'));
      });

      jQuery('section.content-ticket-request .default-variations-container .custom-select').each(function () {
        variations.push({
          id: parseInt($(this).parent('div').data('variation-id')),
          qty: parseInt($(this).val()),
        });
        productId = parseInt($(this).parent('div').data('product-id'));
      });

      jQuery('section.content-ticket-request .multidate-variations-container .event-date-container.d-flex .custom-select').each(function () {
        variations.push({
          id: parseInt($(this).parent('div').data('variation-id')),
          qty: parseInt($(this).val()),
        });
        productId = parseInt($(this).parent('div').data('product-id'));
      });

      if (variations.length === 0 && !productId) {
        productId = parseInt(jQuery('section.content-ticket-request .add_to_cart').data('product-id'));
      }

      if (variations.length > 0 || !!productId) {
        // AJAX add to cart
        let data = {
          action: 'custom_add_to_cart',
          product_id: productId,
          variations: variations,
        };

        $.post(window.tc_ajax.ajaxUrl, data).then((data, status) => {
          if (status !== 'success') {
            throw new Error('Er is een fout opgetreden tijdens het bijwerken van je winkelwagen.');
          }
          return JSON.parse(data);
        }).then((response) => {
          if (response.success === true) {
            window.location.href = response.cart_url;
          } else {
            throw new Error(response.message || 'Er is een fout opgetreden tijdens het bijwerken van je winkelwagen.');
          }
        }).catch((e) => {
          alert(e.message);
        });
      }
    });

    jQuery(document.body).on('updated_checkout', function () {
      updateTicketNames();
    });

    function updateTicketNames() {
      let firstName = jQuery('.woocommerce-billing-fields #billing_first_name').val();
      let lastName = jQuery('.woocommerce-billing-fields #billing_last_name').val();
      let email = jQuery('.woocommerce-billing-fields #billing_email').val();

      jQuery('.tickera_additional_info > .tickera_owner_info > .tc-form-ticket-fields-wrap').each(function () {
        if (jQuery(this).children('h2').text().includes('Standaard') || jQuery(this).children('h2').text().includes('PV Lid')) {
          // if the owner_data_first_name_post_meta (name property ending in whatever) input is empty, fill it with the value from the firstName variable
          if (!jQuery(this).find('input[name^="owner_data_first_name_post_meta"]').val()) {
            let field = jQuery(this).find('input[name^="owner_data_first_name_post_meta"]');
            field.val(firstName);
            field.prop('readonly', true);
          }

          if (!jQuery(this).find('input[name^="owner_data_last_name_post_meta"]').val()) {
            let field = jQuery(this).find('input[name^="owner_data_last_name_post_meta"]');
            field.val(lastName);
            field.prop('readonly', true);
          }

          if (!jQuery(this).find('input[name^="owner_data_owner_email_post_meta"]').val()) {
            let field = jQuery(this).find('input[name^="owner_data_owner_email_post_meta"]');
            field.val(email);
            field.prop('readonly', true);
          }
        }
      });
    }

    jQuery('.flickity-carousel:not(.flickity-carousel-arrows)').flickity({
      groupCells: true,
      imagesLoaded: true,
      contain: true,
      resize: true,
      cellAlign: 'center',
      pageDots: true,
      prevNextButtons: false,
      setGallerySize: false,
    });

    jQuery('.flickity-carousel.flickity-carousel-arrows').flickity({
      groupCells: true,
      imagesLoaded: true,
      contain: true,
      resize: true,
      cellAlign: 'center',
      pageDots: true,
      prevNextButtons: true,
      setGallerySize: false,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js